import React from 'react';
import _ from 'underscore';

import {DateInput} from 'ui-library/inputs/DatetimeInput';

import {DateFieldProps, LABEL_STYLES, Size, SIZES} from './InputConstants';
import InputWrapper from './InputWrapper';

export default function DateField({
  isRequired = false,
  labelStyle = LABEL_STYLES.LABEL,
  size = Size.SMALL,
  isDisabled = false,
  autoFocus = false,
  label = 'Date',
  placeholder = 'Date',
  validDatetimeInputFormats = ['YYYY-MM-DD'],
  datetimePresentationalFormat = 'YYYY-MM-DD',
  ...props
}: DateFieldProps): JSX.Element {
  const id = _.uniqueId('dateField-');
  return (
    <InputWrapper
      button={props.button}
      className={props.className}
      description={props.description}
      dataTestAttrs={props.dataTestAttrs}
      id={id}
      isRequired={isRequired}
      label={label}
      labelStyle={labelStyle}
      size={size}
      help={props.help}
    >
      <DateInput
        validDatetimeInputFormats={validDatetimeInputFormats}
        datetimePresentationalFormat={datetimePresentationalFormat}
        shouldCloseOnSelect={props.shouldCloseOnSelect}
        isDisabled={isDisabled}
        autoFocus={autoFocus}
        className={props.inputClassName}
        hasButton={Boolean(props.button)}
        max={props.max}
        min={props.min}
        onChange={props.onChange}
        onKeyDown={props.onKeyDown}
        placeholder={placeholder}
        size={size}
        value={props.value ? props.value : ''}
        datePickerPopperContainerSelector={props.datePickerPopperContainerSelector}
        wrapperClassName={props.wrapperClassName}
        datetimePickerRef={props.datetimePickerRef}
      />
    </InputWrapper>
  );
}

DateField.SIZES = SIZES;
DateField.LABEL_STYLES = LABEL_STYLES;
